<style scoped></style>

<template>
  <div>
    <table aria-live="polite" aria-relevant="additions">
      <thead>
        <tr>
          <th
            v-for="field in fields"
            v-bind:key="field.id"
            class="text-left text-xs font-medium tracking-wider"
          >
            {{ field.label }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in value" v-bind:key="i">
          <td v-for="field in fields" v-bind:key="field.id">
            <select
              v-if="field.type == 'dropdown'"
              class="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-600 sm:text-sm sm:leading-5"
              :id="`${id}[${i}][${field.id}]`"
              :name="`${id}[${i}][${field.id}]`"
              :required="field.required"
              :value="value[i][field.id]"
              :disabled="disabled"
              @change="
                (e) => {
                  e.preventDefault();
                  onChange(i, field.id, e.target.value);
                }
              "
            >
              <option value="">-----</option>
              <option
                v-for="option in field.options"
                v-bind:key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
            <textarea
              v-if="field.type == 'longtext'"
              rows="3"
              class="form-textarea block w-full border-gray-500 focus:border-blue-600 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :id="`${id}[${i}][${field.id}]`"
              :name="`${id}[${i}][${field.id}]`"
              :required="field.required"
              :value="value[i][field.id]"
              :disabled="disabled"
              @change="
                (e) => {
                  e.preventDefault();
                  onChange(i, field.id, e.target.value);
                }
              "
            />
            <input
              v-if="!['dropdown', 'longtext'].includes(field.type)"
              class="form-input block w-full border-gray-500 focus:border-blue-600 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
              :id="`${id}[${i}][${field.id}]`"
              :name="`${id}[${i}][${field.id}]`"
              :type="field.type ? field.type : 'text'"
              :required="field.required"
              :min="field.min"
              :max="field.max"
              :value="value[i][field.id]"
              :disabled="disabled"
              @change="
                (e) => {
                  e.preventDefault();
                  onChange(i, field.id, e.target.value);
                }
              "
            />
          </td>
          <td>
            <button
              v-if="i !== 0"
              class="inline-flex"
              @click="
                (e) => {
                  e.preventDefault();
                  removeRow(i);
                }
              "
              :aria-label="$t('fields.remove_row')"
            >
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      type="button"
      class="btn-secondary mt-2"
      @click="
        (e) => {
          e.preventDefault();
          addRow();
        }
      "
      :disabled="disabled"
    >
      Voeg toe
    </button>
  </div>
</template>

<script>
export default {
  name: 'ArrayField',
  props: {
    id: String,
    name: String,
    required: Boolean,
    fields: Array,
    initialValue: Array,
    disabled: Boolean,
  },
  data() {
    return {
      value: this.initialValue ? this.initialValue : [{}],
    };
  },
  methods: {
    addRow() {
      this.value.push({});
      this.emitChange();
    },
    removeRow(i) {
      this.$delete(this.value, i);
      this.emitChange();
    },
    onChange(i, name, value) {
      this.value[i][name] = value;
      this.emitChange();
    },
    emitChange() {
      this.$emit('change', {
        target: {
          id: this.id,
          value: this.value,
        },
      });
    },
  },
};
</script>
